import { render } from "./turn-over-export.vue?vue&type=template&id=ae0da400&scoped=true"
import script from "./turn-over-export.vue?vue&type=script&lang=js"
export * from "./turn-over-export.vue?vue&type=script&lang=js"

import "./turn-over-export.vue?vue&type=style&index=0&id=ae0da400&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0da400"]])

export default __exports__